{
  "language": {
    "title": "Gbè ɖiɖe",
    "fr": "Flansɛgbè",
    "en": "Glɛnsigbè",
    "fon": "Fɔngbè",
    "yo": "Yorùbágbè",
    "bba": "Baatɔnun"
  },
  "common": {
    "yes": "Ɛɛn",
    "no": "Eǒ"
  },
  "nav": {
    "home": "Xwé"
  }
}
